const DateTimeFunc = require('@/tbs/util/DateTimeFunc')
const Match = require('@/tbs/model/to/Match')
const match = new Match

const tbs_model_vo_Match = function() {
}

tbs_model_vo_Match.prototype = {
    /* The view object name */
    name: 'match',
    /* The view object instance */
    view: {
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'createSimpleUnionMatch',
            basePath: '',
            rule: {
                chineseName: 'name',
                brandId: 'brandId',
                year: 'year',
                term: 'session',
                areaId: 'areaId',
                gameType: '$numSelection',
                type: '$type',
                beginDate: '$startDate',
                teamCount: 'teamTotal',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateBMUnionMatch2',
            basePath: '',
            rule: {
                id: 'id',
                chineseName: 'name',
                brandId: 'brandId',
                year: 'year',
                term: 'session',
                icon: 'logo',
                backgroundImage2: 'poster',
                areaId: 'areaId',
                gameType: '$numSelection',
                type: '$type',
                beginDate: '$startDate',
                endDate: '$endDate',
                teamCount: 'teamTotal',
                endorser: 'presenter',
                contactor: 'organizer',
                coorganizer: 'coorganizer',
                supervisor: 'advisor',
                description: 'summary'
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMUnionMatch',
            basePath: 'data.match',
            rule: {
                id: 'id',
                status: '$state',
                organizationId: '$accountId',
                brandId: 'brandId',
                brandName: 'brandMatch.name',
                brandLogoUrl: 'brandMatch.logo',
                year: '$year',
                session: '$term',
                name: 'chineseName',
                logoUrl: 'icon',
                posterUrl: 'backgroundImage2',
                area: '$country,province,city,district',
                areaId: '$countryId,provinceId,cityId,districtId',
                numSelection: '$gameType',
                type: '$type',
                startDate: '$beginDate',
                endDate: '$endDate',
                teamTotal: '$teamCount',
                presenter: 'endorser',
                organizer: 'contactor',
                coorganizer: 'coorganizer',
                advisor: 'supervisor',
                summary: 'description'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminDeleteBMUnionMatch',
            basePath: '',
            rule: {
                id: 'id'
            }
        },
    },
    renderOrganizationId: function(accountId) {
        return accountId.toString()
    },
    renderTeamTotal: function(teamCount) {
        return teamCount.toString()
    },
    renderStatus: function(state) {
        state = state || 0
        return (Number(state) + 1).toString()
    },
    renderYear: function(year) {
        return year.toString()
    },
    renderSession: function(term) {
        return term.toString()
    },
    renderStartDate: function(beginDate) {
        return new Date(beginDate)
    },
    renderEndDate: function(endDate) {
        return endDate ? new Date(endDate) : null
    },
    renderType: function(type) {
        return (type == 'league') ? '1' : '2'
    },
    renderNumSelection: function(gameType) {
        return gameType.replace(/\D/g, '')
    },
    formatGameType: function(numSelection) {
        return match.localeProp('match-number-selection', {num: numSelection})
    },
    formatType: function(type) {
        type = type.toString()
        if (type == '1') {
            return 'league'
        }
        else if (type == '2') {
            return 'cup'
        }
    },
    formatBeginDate: function(startDate) {        
        return DateTimeFunc.formatDate(startDate, 'yyyy-MM-ddThh:mm:ss+0800')
    },
    formatEndDate: function(endDate) {        
        if (endDate) {
            return DateTimeFunc.formatDate(endDate, 'yyyy-MM-ddThh:mm:ss+0800')
        }
    },
    renderArea: function(country, province, city, district) {
        let area = ''
        if (country && !province) {
            area = country
        }
        else {
            area = province
        }
        if (city) {
            area += ' ' + city
        }
        if (district) {
            area += ' ' + district
        }
        return area
    },
    renderAreaId: function(countryId, provinceId, cityId, districtId) {
        let areaId = countryId
        if (provinceId) {
            areaId = provinceId
        }
        if (cityId) {
            areaId = cityId
        }
        if (districtId) {
            areaId = districtId
        }
        return areaId
    },
}

module.exports = tbs_model_vo_Match